import firebase from 'firebase/compat/app';
import { firstValueFrom } from 'rxjs';

import type { DBDocObject } from '@pwp-common';

import { getSetOptionsFromMode } from '../batch/set-options-for-mode';

import type { UpdateInTransactionInput } from './interfaces';

/**
 * Read-modify-write a single document inside a transaction.
 */
export const updateInTransaction = async <T extends DBDocObject>(input: UpdateInTransactionInput<T>): Promise<void> => {
  const { instance, db, docRef, transform } = input;

  await db.firestore.runTransaction(async (transaction: firebase.firestore.Transaction) => {
    const snapshot = await transaction.get(docRef);
    const currentValue = instance.getObjectFromFirebase(snapshot);
    if (currentValue === undefined) {
      return;
    }

    const updatedValue = transform(currentValue);
    if (updatedValue === undefined) {
      return;
    }

    const updateData = await firstValueFrom(instance.getSerializedObjWithGenericFields(updatedValue, 'update'));
    transaction.set(docRef, updateData, getSetOptionsFromMode('update'));
  });
};
